const { NODE_ENV } = process.env

export const DEBUG = NODE_ENV === 'development'
export const SENTRY = NODE_ENV === 'production'

const url = process.env.REACT_APP_API ?? 'localhost'
const port = process.env.REACT_APP_PORT ?? '4000'
export const API_URL_FULL = `http${port === '443' ? 's' : ''}://${url}:${port}`
